import React from 'react';
import Link, { LinkProps } from '@amzn/awsui-components-react/polaris/link';

export function ExternalLink(props: LinkProps) {
  return <Link href="#" external={true} externalIconAriaLabel="Opens in a new tab" {...props} />;
}
